import { Button, Checkbox, Modal, Table } from 'antd'
import React from 'react'
import vip_download_excel_icon from '../../../../images/vip_download_excel.png'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import { setPaymentVisible } from '../../../../actions/main'
import sensors from 'sa-sdk-javascript'
const { Column } = Table

export default ({
  customers,
  successNum,
  errorNum,
  isVisibleOnlyError,
  setIsVisibleOnlyError,
  handleImportClick,
  handleLocationsErrorClick,
  allCustomerCount,
  onAdjust
}) => {
  const dispatch = useAppDispatch()
  const isVip = useAppSelector((state) => state.group.isVip)
  const groupId = useAppSelector((state) => state.group.groupId)

  const failedCustomers = customers.filter((record) => !record.status)
  const successCustomers = customers.filter((record) => record.status)
  let records

  if (isVisibleOnlyError) {
    records = failedCustomers
  } else {
    records = [...failedCustomers, ...successCustomers]
  }

  records = records.map((record, index) => ({
    ...record,
    key: index + 1
  }))

  // 065 不再限制导入客户数量
  // const handleOpenVip = () => {
  //   dispatch(setPaymentVisible(true, 'batchImportOver50'))
  //   sensors.track('web_click_button_workgroup_go_vip_trigger', {
  //     place: 'customerInfo',
  //     functionType: 'customerNum',
  //     groupID: groupId
  //   })
  // }

  return (
    <div className="preview-wrapper">
      <div className="import-info">
        <div className="info-title">客户信息预览</div>
        <div className="info-content">
          <div className="info-left">
            <span>
              上传客户数：<i>{successNum + errorNum}</i>
            </span>
            <span>
              定位成功：<i>{successNum}</i>
            </span>
            <span>
              定位失败，无法导入：{' '}
              <i style={{ color: '#D40000' }}>{errorNum}</i>
            </span>
            <span>
              <Checkbox
                onChange={(e) => {
                  setIsVisibleOnlyError(e.target.checked)
                }}
              >
                仅显示失败
              </Checkbox>
            </span>
          </div>
          <div className="info-right">
            <Button
              type="primary"
              onClick={() => {
                // if (!isVip && allCustomerCount > 50) {
                //   handleOpenVip()
                // } else {

                // }
                if (errorNum > 0) {
                  Modal.confirm({
                    content: `有${errorNum}个客户定位失败，是否继续导入其他客户`,
                    cancelText: '去调整',
                    okText: '继续导入',
                    onOk: handleImportClick
                  })
                } else {
                  handleImportClick()
                }
              }}
            >
              确认导入
              {/* {allCustomerCount > 50 && (
                <img
                  alt=""
                  src={vip_download_excel_icon}
                  style={{
                    width: 20,
                    height: 20,
                    verticalAlign: 'bottom'
                  }}
                />
              )} */}
            </Button>
            <Button onClick={handleLocationsErrorClick}>
              下载定位失败客户
            </Button>
          </div>
        </div>

        {/* {!isVip && allCustomerCount > 50 && (
          <div className="vip-tip-wrapper">
            <div className="vip-tip">
              免费版最多50个客户，开通<b>团队会员</b>不限量
              <span
                className="open-vip"
                onClick={() => {
                  handleOpenVip()
                }}
              >
                [立即开通]
              </span>
            </div>
          </div>
        )} */}
      </div>
      <div className="table-container">
        <Table
          bordered
          dataSource={records}
          scroll={{ y: window.innerHeight - 402 }}
          style={{ margin: '0 20px' }}
          pagination={false}
        >
          <Column
            title="序号"
            key="key"
            dataIndex="key"
            render={(key) => {
              return key
            }}
          />
          <Column
            title="客户名称"
            key="customerName"
            dataIndex="customerName"
          />
          <Column title="客户地址" key="address" dataIndex="address" />
          <Column
            title="跟进人电话"
            key="ownerMobiles"
            dataIndex="ownerMobiles"
            render={(ownerMobiles) =>
              ownerMobiles.map((mobile) => <div>{mobile}</div>)
            }
          />
          <Column
            title="联系人姓名"
            key="contractName"
            dataIndex="contractName"
          />
          <Column
            title="联系人电话"
            key="contractTelPhone"
            dataIndex="contractTelPhone"
          />
          <Column
            title="定位经纬度"
            render={(text) => {
              if (text.lat && text.lng) {
                return text.lat + '，' + text.lng
              }
              return ''
            }}
          />
          <Column
            title="定位状态"
            key="status"
            dataIndex="status"
            render={(text) => {
              if (text) {
                return <span style={{ color: '' }}>成功</span>
              } else {
                return <span style={{ color: '#D40000' }}>失败</span>
              }
            }}
          />
          <Column
            title="操作"
            render={(text, record) => {
              return (
                <a
                  onClick={() => onAdjust(record)}
                  style={{ color: '#0093FF' }}
                >
                  调整定位
                </a>
              )
            }}
          />
        </Table>
      </div>
    </div>
  )
}
